import createTableStore from "ds/components/Table/store/useTableStore";

import { SPACE_API_KEYS_COLUMN_CONFIG, SPACE_API_KEYS_COLUMNS_STORAGE_KEY } from "./constants";

const useSpaceDetailsApiKeysTableStore = createTableStore({
  storageKey: SPACE_API_KEYS_COLUMNS_STORAGE_KEY,
  config: SPACE_API_KEYS_COLUMN_CONFIG,
});

export default useSpaceDetailsApiKeysTableStore;
